import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import Loader from 'features/Loader/Loader';
import {
  handleSignInWithEmailLink
} from '../../ducks/actionsAuthActions';
import InvalidAction from '../InvalidAction/InvalidAction';

class SignInWithEmailLink extends React.Component {
  componentDidMount() {
    this.props.handleSignInWithEmailLink(this.props.code);
  }

  render() {
    let { signInLinkSuccess, signInLinkError, loading } = this.props;

    if (loading) {
      return (<Loader/>);
    }

    if (signInLinkSuccess) {
      return <Redirect to={{ pathname: '/' }} />;
    } else {
      return (
        <InvalidAction
          title="Something Went Wrong!"
          description={signInLinkError}
        />
      );
    }
  }

}

function mapStateToProps(state) {
  return {
    signInLinkSuccess: state.actionsReducer.signInLinkSuccess,
    signInLinkError: state.actionsReducer.signInLinkError,
    loading: state.actionsReducer.loading,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    handleSignInWithEmailLink: code => dispatch(handleSignInWithEmailLink(code))
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SignInWithEmailLink);
